import { jsxs, jsx } from "react/jsx-runtime";
import { Box } from "@mui/material";
import { SpaceXxs } from "@nxt-costco-com/forge-design-tokens";
import { CustomSingleSkeleton } from "../CustomSingleSkeleton/CustomSingleSkeleton.js";
import { COMPONENT_NAME, CHECKBOX_SIZE, BORDER_RADIUS_STANDARD, CHECKBOX_CHECK_ID, CHECKBOX_LABEL_ID } from "../constants.js";
import { SkeletonVariant } from "../enums.js";
const CheckboxSkeleton = ({
  hiddenText,
  width
}) => {
  const widthValue = width ?? "100%";
  return /* @__PURE__ */ jsxs(
    Box,
    {
      sx: {
        display: "flex",
        gap: SpaceXxs,
        width: widthValue
      },
      "data-testid": COMPONENT_NAME,
      children: [
        /* @__PURE__ */ jsx(
          CustomSingleSkeleton,
          {
            "data-testid": CHECKBOX_CHECK_ID,
            height: CHECKBOX_SIZE,
            hiddenText,
            sx: {
              borderRadius: BORDER_RADIUS_STANDARD,
              flex: "none"
            },
            variant: SkeletonVariant.Rectangular,
            width: CHECKBOX_SIZE
          }
        ),
        /* @__PURE__ */ jsx(
          CustomSingleSkeleton,
          {
            "data-testid": CHECKBOX_LABEL_ID,
            height: CHECKBOX_SIZE,
            hiddenText,
            sx: {
              borderRadius: BORDER_RADIUS_STANDARD
            },
            variant: SkeletonVariant.Rectangular,
            width: "100%"
          }
        )
      ]
    }
  );
};
export {
  CheckboxSkeleton
};
